import { ChangeDetectionStrategy, Component, inject, Input, signal, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MODAL_TOKEN, ModalProvider } from '@core';

@Component({
  selector: 'lib-feature-flag-confirm-modal',
  templateUrl: './feature-flag-confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, FormsModule]
})
export class FeatureFlagConfirmModalComponent {
  @Input({ required: true }) flagName!: string;
  @Input({ required: true }) newValue!: boolean;
  @Input({ required: true }) action!: () => void;

  readonly inputValue: WritableSignal<string> = signal<string>('');

  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  closeModal(): void {
    this.modalProvider.dismissAllStoredModals();
  }

  handle(): void {
    if (this.inputValue().toLowerCase() !== 'tak') {
      return;
    }

    this.modalProvider.dismissAllStoredModals();
    this.action();
  }
}
